module.exports = __webpack_public_path__ + "img/htrc-logo.ea569afb.png";